import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { cn } from "./ClassName";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

/**
 * please use the new CheckboxIcon component instead in CheckboxIcon.tsx
 */
export const customCheckmarkOverlay = (
  checked: boolean,
  size: number,
  square = false,
  color: string = "blue",
) => {
  const padSize = 2;
  let colorClass = "";
  switch (color) {
    case "blue":
      colorClass = "tw-bg-blue-2";
      break;
    case "orange":
      colorClass = "tw-bg-orange-1";
      break;
    case "green":
      colorClass = "tw-bg-green-1";
      break;
    default:
      colorClass = "tw-bg-blue-2";
  }
  if (checked) {
    return (
      <FontAwesomeIcon
        className={cn(
          !square ? `tw-rounded-full` : "tw-rounded-[2px]",
          ` ${colorClass} tw-font-bold tw-text-white`,
        )}
        style={{
          // Tailwind was being weird with dynamically created tags so these are in `style`
          padding: padSize,
          height: size - 2 * padSize,
          width: size - 2 * padSize,
        }}
        icon={faCheck}
      />
    );
  } else {
    return (
      <div
        className={cn(
          !square ? `tw-rounded-full` : "tw-rounded-[2px]",
          `tw-border-[1.5px] tw-border-solid tw-border-gray-4`,
        )}
        style={{ height: size, width: size }}
      />
    );
  }
};

interface RoundedCheckboxProps {
  checked: boolean;
  name?: string;
  value?: string;
  id?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
}

/**
 * please use the new CheckboxInput component instead in CheckboxIcon.tsx
 */
export function RoundedCheckbox(
  props: RoundedCheckboxProps,
): React.JSX.Element {
  return (
    <>
      <input
        className="tw-absolute !tw-mt-0 tw-h-[20px] tw-w-[20px] tw-cursor-pointer tw-opacity-0"
        type="checkbox"
        id={props.name ?? ""}
        name={props.name ?? ""}
        value={props.value ?? ""}
        onChange={props.onChange}
        checked={props.checked}
      />
      <label
        htmlFor={props.name}
        className={`tw-mr-4 tw-mt-2 tw-inline-flex tw-cursor-pointer tw-items-center tw-rounded-[2.5rem] tw-border-[1.5px] tw-border-solid tw-px-4 tw-py-3 ${
          props.checked
            ? "tw-border-blue-1 tw-bg-blue-light-1"
            : "tw-border-gray-light-0 tw-bg-gray-light-3 hover:tw-bg-gray-light-4"
        }`}
      >
        {customCheckmarkOverlay(props.checked, 20)}
        <div className="tw-m-2">{" " + props.name}</div>
        {props.children}
      </label>
    </>
  );
}
